// extracted by mini-css-extract-plugin
export var locationCard = "_eq-0";